export const heroContent = {
  badge: '아이돌 팬픽 독자를 위한 Scene',
  titleLine1: '내 커플링 맞춤 팬픽,',
  titleAccent: '재밌는 것만 골라서',
  titleLine3: '바로 볼 수 있어요.',
  subtitle: '없는 게 아니에요. 묻혀있는 거예요.',
  subtitleBr: '내 커플링 설정하면, 재밌는 장면부터 바로 보여줘요.',
  secondaryCta: 'Scene이 뭔가요?',
} as const

export const heroSpeechBubbles = [
  '왜 내 커플링으로 쓴 팬픽은 없는 거야...',
  '팬픽이 너무 많은데 뭐가 재밌는지 모르겠어',
] as const

export const flowSectionContent = {
  label: 'POINTS',
  title: '팬픽 탐색이 쉬워지는 핵심 포인트',
  description:
    '원하는 이름과 커플링부터 정하고, 카피페 미리보기로 취향만 빠르게 확인해보세요.',
} as const

export const flowScreens = [
  {
    key: 'preference',
    step: '01',
    label: '등장인물 설정',
    title: '김여주 자리에, 내가 원하는 이름으로.',
    description:
      '내 이름도 되고, 차애 이름도 돼요. 원하는 커플링으로 팬픽을 새로 읽어보세요.',
    helper: '등장인물을 골라주세요',
    combinations: [
      {
        leftLabel: '내 이름',
        rightLabel: '최애 이름',
        leftActive: true,
        rightActive: true,
      },
      {
        leftLabel: '차애 이름',
        rightLabel: '최애 이름',
        leftActive: false,
        rightActive: false,
      },
    ],
    combinationDivider: '또는',
    footer: '다음 → 피드 시작',
  },
  {
    key: 'feed',
    step: '02',
    label: '카피페로 먼저 보기',
    title: '처음부터 다 읽을 필요 없어요.',
    description:
      '채팅·썰 형태로 변환된 명장면만 먼저 맛보고, 취향에 맞으면 그때 원작으로 넘어가요. 팬픽 수백 편도 부담 없이 탐색할 수 있어요.',
    highlights: [
      '채팅·썰 형태로 변환된 명장면만 먼저 볼 수 있어요.',
      '취향에 맞는 장면이 나오면 바로 원작으로 이어 읽어요.',
      '팬픽 수백 편도 부담 없이 빠르게 탐색할 수 있어요.',
    ],
    tabs: {
      thread: {
        label: '썰형 피드',
        nickname: '무대뒤목격담',
        content1: '리허설 끝나고 대기실 문 닫히는 순간 분위기 확 바뀌는 거 실화냐.',
        content2: '팬싸 끝나고 눈 한 번 마주치는 장면인데 이건 바로 원문 찾아가야 되는 타입.',
        cta: '이 소설 원문 보기',
      },
      chat: {
        label: '채팅형 피드',
        leftName: '도윤',
        rightName: '이안',
        bubble1: '오늘 무대 끝나고도 계속 네 생각났어.',
        bubble2: '그러면 오늘은 끝나고 그냥 가지 마.',
        bubble3: '이 정도면 다음 장면 안 보고 못 버티지.',
        cta: '이 소설 원문 보기',
      },
    },
  },
] as const

export const faqSectionContent = {
  label: 'FAQ',
  title: '자주 묻는 질문',
  description: 'Scene 사용 전에 많이 궁금해하시는 내용을 모았어요.',
} as const

export const faqItems = [
  {
    question: 'Q. 유료인가요?',
    answers: [
      'A. 기본은 무료예요.',
      '다만 채팅 일부는 하트를 써서 열어볼 수 있어요.',
      '하트는 앱 내에서 무료로도 받을 수 있어요.',
    ],
  },
  {
    question: 'Q. 아무 캐릭터나 넣을 수 있나요?',
    answers: [
      'A. 아이돌, 애니 캐릭터처럼 널리 알려진 인물이라면 검색해서 바로 넣을 수 있어요.',
      '일반인은 본인 이름만 입력할 수 있어요.',
    ],
  },
  {
    question: 'Q. 제 작품도 등록할 수 있나요?',
    answers: ['A. 작가 모집 페이지에서 신청하면 FanHearts 팀이 연락드려요.'],
  },
  {
    question: 'Q. 원작도 내 커플링으로 볼 수 있나요?',
    answers: [
      'A. 작가님이 커플링 변경을 허용한 작품은 가능해요.',
      '변경을 원하지 않는 작가님의 작품은 원작 그대로 보여져요.',
    ],
  },
] as const

export const finalCtaContent = {
  label: 'FINAL CTA',
  title: '내 커플링 맞춤 팬픽,\n재밌는 것만 골라서 바로 보세요.',
  description: '묻혀 있던 팬픽도 Scene에서 더 빠르게 찾을 수 있어요.',
  secondaryCta: 'Scene이 뭔가요?',
} as const
